import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_grid2d } from '@/hooks/store/use_slices';
import { LOCAL__images_add_to_loading_pool } from '@/state/images/load/LOCAL__images_add_to_loading_pool';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';

export function WATCHER_IMAGES__add_to_loading_pool_from_generation_current_grid2d() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (generation_current.is_stub()) return;
    if (!grids2d_map.has(generation_current._id)) return; //not loaded yet

    let grid2d = grids2d_map.get_or_assert(generation_current._id);
    assert_instanceof(grid2d, DTO__grid2d_generation);

    let cells_list = grid2d.get_generation_chunk().cells_list;
    cells_list = cells_list.filter(cell => cell.image.is_stub()); //keep only without image
    cells_list = cells_list.filter(cell => !cell.hash_sha256_content.is_empty_hash_sha256()); //keep only with content

    let hashes_to_load: string[] = cells_list.map(cell => cell.hash_sha256_content);

    dispatch(LOCAL__images_add_to_loading_pool(hashes_to_load));
  }, [generation_current, grids2d_map]);

  return null;
}
